import React from "react";

import { Box, Typography } from "@mui/material";

interface Props {
  text: string;
}

export const CommentText: React.FC<Props> = ({ text }) => {
  return (
    <Box sx={{ pl: "50px" }}>
      <Typography
        sx={{
          fontSize: "15px",
          fontWeight: 400,
          color: "#071f35",
          lineHeight: "20px",
          whiteSpace: "pre-wrap"
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

